import React, {useCallback} from 'react';

import {useI18n} from '../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../elements/ButtonLink';
import {dialogConfirm} from '../../../elements/Dialog/dialogs';
import Icon from '../../../elements/icons/Icon';
import Modal from '../../../elements/Modal/Modal';
import loginViaLinkedin from '../linkedin';
import styles from './EmailUsedDialog.module.scss';

const EmailUsedDialog = props => {
    const {has_linkedin, email, show, onDifferentEmail, onClose} = props,
        i18n = useI18n();

    const handleDifferentEmail = useCallback(
        async e => {
            if (await dialogConfirm(i18n['label.account-already-exists-register-warning'])) {
                onDifferentEmail();
            }
        },
        [i18n, onDifferentEmail]
    );

    const handleLogin = useCallback(
        e => {
            if (has_linkedin) {
                e.preventDefault();
                loginViaLinkedin();
            }
        },
        [has_linkedin]
    );

    return (
        <Modal title={i18n['label.account-already-exists']} onClose={onClose} show={show}>
            <p>{i18n['label.account-already-exists-desc']}</p>
            <ButtonLink className={styles.login} href={has_linkedin ? `/login?email=${email}` : `/login/email?email=${email}`} onClick={handleLogin}>
                {i18n['label.loginAction']}
            </ButtonLink>
            <br />
            {!has_linkedin ? (
                <>
                    <p>{i18n['label.account-already-exists-no-password']}</p>
                    <ButtonLink className={styles.passwordRecover} href={`/password_recover?email=${email}`}>
                        {i18n['label.account-already-exists-set-password']}
                    </ButtonLink>
                    <br />
                </>
            ) : null}
            <br />
            <div className={styles.useDifferent} onClick={handleDifferentEmail}>
                {i18n['label.account-already-exists-register']}
                <Icon src="/img/chevron-right-darkgray.png" color="#0e81fd" />
            </div>
        </Modal>
    );
};

export default EmailUsedDialog;
